import { Injectable } from '@angular/core';
import { IAlloxManagerEnvironment } from '../common';

declare const ALLOX_MANAGER_ENVIRONMENT: IAlloxManagerEnvironment;

@Injectable({ providedIn: 'root' })
export class EnvironmentService {
  public get API_DOMAIN() { return ALLOX_MANAGER_ENVIRONMENT.API_DOMAIN; }
  public get AUTH() { return ALLOX_MANAGER_ENVIRONMENT.AUTH; }
  public get JS_PATH() { return ALLOX_MANAGER_ENVIRONMENT.ALLOX_JS_PATH; }
  public get ENV() { return ALLOX_MANAGER_ENVIRONMENT.ENV; }
  public get SAMPLE_PAGE_WEB() { return ALLOX_MANAGER_ENVIRONMENT.SAMPLE_PAGE_WEB; }
  public get SAMPLE_PAGE_S2S() { return ALLOX_MANAGER_ENVIRONMENT.SAMPLE_PAGE_S2S; }
  public get SAMPLE_PAGE_SDK() { return ALLOX_MANAGER_ENVIRONMENT.SAMPLE_PAGE_SDK; }
}
